export default "__VITE_ASSET__BP5ahkWq__"